import React from 'react';

import ReportsListTemplate from 'src/components/ReportsListTemplate';

const ReportsList = props => <ReportsListTemplate {...props} />;

export default ReportsList;
